import { ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';
import { NgClass } from '@angular/common';
import ShortUniqueId from 'short-unique-id';
import { ClickPreventDefaultDirective } from '../../directives';

@Component({
  selector: 'mwe-card-selectable',
  templateUrl: './card-selectable.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, ClickPreventDefaultDirective],
})
export class CardSelectableComponent {
  inputID = input('selectable-card-' + new ShortUniqueId({ dictionary: 'alpha' }).rnd(8));
  isInvalid = input(false);
  isSelected = model<boolean>(false);
  disabled = input(false);
  readonly = input(false);
  readonly changed = output<boolean>();

  toggle() {
    if (this.readonly()) return;

    this.isSelected.update(v => !v);
    this.changed.emit(this.isSelected());
  }
}
